import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import StatsCard from '../StatsCard';
import { CountContainerSx, CountSx, SpinnerSx, ZeroCountSx } from './styles';
import { SyncedCardProps } from './types';

const SyncedCard = (props: SyncedCardProps) => {
  const { 'data-testid': dataTestId, syncedCount, processing } = props;

  return (
    <StatsCard
      data-testid={dataTestId}
      title="Synced Assets"
      value={
        <Stack direction="row" sx={CountContainerSx}>
          <Typography sx={syncedCount === 0 ? ZeroCountSx : CountSx}>
            {syncedCount}
          </Typography>
          {processing && <CircularProgress sx={SpinnerSx} size="small" />}
        </Stack>
      }
    />
  );
};

export default SyncedCard; 
